// @ts-expect-error
export default (store) => (next) => (action) => {
  next({ ...action }); // convert class action to object
};
